var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'redux-form';
import APInput from '../common/APInput';
import APButton from '../common/APButton';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import APRadio from '../common/APRadio/APRadio';
import { required, email } from '../../helpers/formValidations';
import { styleNames } from '../../propTypes/commonComponent';
import '../../styles/components/common/StandaloneForm.css';
import './SimpleProblemLoggingInForm.css';
var baseClasses = getBEMClasses('standalone-form');
var simpleProblemLoggingInFormClasses = getBEMClasses('forgot-password-form');
export var SimpleProblemLoggingInFormComponent = function (_React$Component) {
  _inherits(SimpleProblemLoggingInFormComponent, _React$Component);
  function SimpleProblemLoggingInFormComponent(props) {
    _classCallCheck(this, SimpleProblemLoggingInFormComponent);
    var _this = _possibleConstructorReturn(this, (SimpleProblemLoggingInFormComponent.__proto__ || Object.getPrototypeOf(SimpleProblemLoggingInFormComponent)).call(this, props));
    _this.toggleFormType = function () {
      return _this.setState({
        resetPassword: !_this.state.resetPassword
      });
    };
    _this.sendEmail = function (values) {
      var _this$props = _this.props,
        sendResetPasswordEmail = _this$props.sendResetPasswordEmail,
        resendVerificationEmail = _this$props.resendVerificationEmail;
      if (_this.state.resetPassword) {
        return sendResetPasswordEmail(values.Email);
      }
      return resendVerificationEmail(values);
    };
    _this.state = {
      resetPassword: true
    };
    return _this;
  }
  _createClass(SimpleProblemLoggingInFormComponent, [{
    key: 'render',
    value: function render() {
      var context = this.context;
      var _props = this.props,
        handleSubmit = _props.handleSubmit,
        submitting = _props.submitting,
        pristine = _props.pristine,
        invalid = _props.invalid;
      var _props2 = this.props,
        useEmailAsUsername = _props2.useEmailAsUsername,
        showOptions = _props2.showOptions;
      var validate = [required];
      var label = context.t('Username');
      if (useEmailAsUsername || !this.state.resetPassword) {
        validate.push(email);
        label = context.t('Email');
      }
      return React.createElement(Form, {
        onSubmit: handleSubmit(this.sendEmail),
        className: baseClasses('form') + ' ' + simpleProblemLoggingInFormClasses('form')
      }, showOptions ? React.createElement(React.Fragment, null, React.createElement('div', {
        className: baseClasses('information-text') + ' ' + simpleProblemLoggingInFormClasses('information-text')
      }, context.t('Select your issue type and provide us with your {label} below. We will follow up with a solution shortly.', {
        label: label.toLowerCase()
      })), React.createElement('hr', {
        className: baseClasses('separator')
      }), React.createElement('section', {
        className: baseClasses('radio-list')
      }, React.createElement(APRadio, {
        name: 'type',
        checked: this.state.resetPassword,
        onChange: this.toggleFormType,
        customClass: simpleProblemLoggingInFormClasses(),
        label: context.t('I’m an existing user and I forgot my password.'),
        id: 'problem-login-radio1'
      }), React.createElement(APRadio, {
        name: 'type',
        checked: !this.state.resetPassword,
        onChange: this.toggleFormType,
        customClass: simpleProblemLoggingInFormClasses(),
        label: context.t('I’m a new user and I haven’t received my verification email.'),
        id: 'problem-login-radio2'
      }))) : React.createElement('div', {
        className: baseClasses('information-text') + ' ' + simpleProblemLoggingInFormClasses('information-text')
      }, context.t('Provide us with your {label} below. We will follow up with reset instructions.', {
        label: label.toLowerCase()
      })), React.createElement(APInput, {
        type: 'text',
        name: 'Email',
        customClass: simpleProblemLoggingInFormClasses(),
        label: label,
        validate: validate
      }), React.createElement('hr', {
        className: simpleProblemLoggingInFormClasses('separator')
      }), React.createElement(APButton, {
        type: 'submit',
        disabled: submitting || pristine || invalid,
        customClass: simpleProblemLoggingInFormClasses(),
        styleName: styleNames.additive
      }, submitting ? context.t('Processing...') : context.t('Send Email')));
    }
  }]);
  return SimpleProblemLoggingInFormComponent;
}(React.Component);
SimpleProblemLoggingInFormComponent.propTypes = {
  handleSubmit: PropTypes.func.isRequired
};
SimpleProblemLoggingInFormComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default SimpleProblemLoggingInFormComponent;